module.exports = __webpack_public_path__ + "img/appAsset-brand--axteroid-icon.3cfb8594.svg";